module.exports = __webpack_public_path__ + "img/fire_one.9ec23930.png";